import React, { Suspense, lazy } from 'react';
import { Header } from './components/ToxicDetector/Header';
import { HeroSection } from './components/ToxicDetector/HeroSection';
import { TrustSection } from './components/ToxicDetector/TrustSection';
import { SocialProofSection } from './components/ToxicDetector/SocialProofSection';
import { Footer } from './components/ToxicDetector/Footer';
import { MetaTags } from './components/SEO/MetaTags';
import { ProStatusListener } from './components/ProStatusListener';
// Lazy-load below-the-fold sections
const CredentialsImageSection = lazy(() => import('./components/ToxicDetector/CredentialsImageSection').then(m => ({
  default: m.CredentialsImageSection
})));
const HiddenToxicitySection = lazy(() => import('./components/ToxicDetector/HiddenToxicitySection').then(m => ({
  default: m.HiddenToxicitySection
})));
const DetectionImageSection = lazy(() => import('./components/ToxicDetector/DetectionImageSection').then(m => ({
  default: m.DetectionImageSection
})));
const ToxicityAuditSection = lazy(() => import('./components/ToxicDetector/ToxicityAuditSection').then(m => ({
  default: m.ToxicityAuditSection
})));
const WarningImageSection = lazy(() => import('./components/ToxicDetector/WarningImageSection').then(m => ({
  default: m.WarningImageSection
})));
const FeaturesSection = lazy(() => import('./components/ToxicDetector/FeaturesSection').then(m => ({
  default: m.FeaturesSection
})));
const HowItWorksSection = lazy(() => import('./components/ToxicDetector/HowItWorksSection').then(m => ({
  default: m.HowItWorksSection
})));
const GuaranteesSection = lazy(() => import('./components/ToxicDetector/GuaranteesSection').then(m => ({
  default: m.GuaranteesSection
})));
const IntroImageSection = lazy(() => import('./components/ToxicDetector/IntroImageSection').then(m => ({
  default: m.IntroImageSection
})));
const ToolsSection = lazy(() => import('./components/ToxicDetector/ToolsSection').then(m => ({
  default: m.ToolsSection
})));
const ComparisonSection = lazy(() => import('./components/ToxicDetector/ComparisonSection').then(m => ({
  default: m.ComparisonSection
})));
const PricingSection = lazy(() => import('./components/ToxicDetector/PricingSection').then(m => ({
  default: m.PricingSection
})));
const FAQSection = lazy(() => import('./components/ToxicDetector/FAQSection').then(m => ({
  default: m.FAQSection
})));
const JourneyImageSection = lazy(() => import('./components/ToxicDetector/JourneyImageSection').then(m => ({
  default: m.JourneyImageSection
})));
const CTASection = lazy(() => import('./components/ToxicDetector/CTASection').then(m => ({
  default: m.CTASection
})));
const SEONavigationSection = lazy(() => import('./components/ToxicDetector/SEONavigationSection').then(m => ({
  default: m.SEONavigationSection
})));
// Lazy-load non-critical UI that appears after user interaction or scroll
const PromoBanner = lazy(() => import('./components/Notifications/PromoBanner').then(m => ({
  default: m.PromoBanner
})));
const FloatingActionBar = lazy(() => import('./components/ToxicDetector/FloatingActionBar').then(m => ({
  default: m.FloatingActionBar
})));
export function App() {
  return <>
      <ProStatusListener data-id="element-19" />
      <MetaTags data-id="element-20" />
      <Suspense fallback={null} data-id="element-21">
        <PromoBanner data-id="element-22" />
      </Suspense>
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-23">
        <Header data-id="element-24" />
        <main data-id="element-25">
          {/* Above the fold - eager loaded */}
          <HeroSection data-id="element-26" />
          <TrustSection data-id="element-27" />
          <SocialProofSection data-id="element-28" />

          {/* Below the fold - lazy loaded */}
          <Suspense fallback={<div className="min-h-[50vh] flex items-center justify-center" data-id="element-30">
                <div className="w-8 h-8 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" data-id="element-31" />
              </div>} data-id="element-29">
            <CredentialsImageSection data-id="element-32" />
            <HiddenToxicitySection data-id="element-33" />
            <DetectionImageSection data-id="element-34" />
            <ToxicityAuditSection data-id="element-35" />
            <WarningImageSection data-id="element-36" />
            <FeaturesSection data-id="element-37" />
            <HowItWorksSection data-id="element-38" />
            <GuaranteesSection data-id="element-39" />
            <IntroImageSection data-id="element-40" />
            <ToolsSection data-id="element-41" />
            <ComparisonSection data-id="element-42" />
            <PricingSection data-id="element-43" />
            <FAQSection data-id="element-44" />
            <JourneyImageSection data-id="element-45" />
            <CTASection data-id="element-46" />
            <SEONavigationSection data-id="element-47" />
          </Suspense>
        </main>
        <Footer data-id="element-48" />
      </div>
      <Suspense fallback={null} data-id="element-49">
        <FloatingActionBar data-id="element-50" />
      </Suspense>
    </>;
}